/* eslint-disable react-hooks/exhaustive-deps */
import React, { FC, useEffect, useState } from 'react';

import { Skeleton } from '@mui/material';
import LoadingScreen from 'components/LoadingScreen/LoadingScreen';
import { useAuth } from 'utils/contexts/auth-context';
import { useNavigate } from 'react-router-dom';
import { useMeetingStatus } from 'utils/contexts/meeting-status-context';
import CardAlertContainer from 'shared/components/alert-card/alert-card.component';
import LoadingButton from 'shared/components/button/loading-button.component';
import LanguageSelector from 'shared/components/language-selector/card-selector.component';
import useRequestInterpreter from './hooks/request.service';
import Page from 'components/page/page.component';
import { STRINGS, UserType } from 'utils/constants';
import { useFlags } from 'launchdarkly-react-client-sdk';
import Unavailable from 'components/Unavailable/Unavailable';

const JoinInterpreter: FC = () => {
  const { location, isLoggedIn, sorensonUser, loading } = useAuth();
  const {
    submit,
    loading: requestLoading,
    canRequest,
    hearingPhoneNumber,
  } = useRequestInterpreter();
  const {
    isInterpreterConnected,
    isInMeeting,
    isHost,
    currentMeeting,
    interpreterRequest,
    isGettingMeetingInfo,
    initialLoad,
  } = useMeetingStatus();
  const navigate = useNavigate();

  const [language, setLanguage] = useState<string>();

  const { languageSelector, vriLanguageSelector, zoomKillswitch } = useFlags();

  const handleSumbit = () => {
    submit(language);
  };

  useEffect(() => {
    if (isInterpreterConnected) {
      navigate('/thankyou');
    }
  }, [isInterpreterConnected]);

  useEffect(() => {
    if (
      !loading &&
      !location &&
      location === null &&
      isLoggedIn &&
      !zoomKillswitch &&
      sorensonUser.userType === UserType.VRI
    ) {
      navigate('/location');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sorensonUser, isLoggedIn]);

  return (
    <>
      {!interpreterRequest.inProcess ? (
        <Page pageTitle='Get Interpreter' showHeader={isLoggedIn}>
          {!zoomKillswitch ? (
            <>
              {!initialLoad && !canRequest && hearingPhoneNumber ? (
                <CardAlertContainer
                  severity='error'
                  mainText='Please first start or create a Zoom meeting to get an ASL
                    interpreter.'
                />
              ) : null}
              {!isInMeeting && !initialLoad && !isHost && canRequest ? (
                <CardAlertContainer severity='error'>
                  Please <b>first</b> start or create a Zoom meeting to get an
                  ASL interpreter.
                </CardAlertContainer>
              ) : null}
              {interpreterRequest.error && (
                <CardAlertContainer
                  severity='error'
                  mainText={
                    interpreterRequest.errorMessage ||
                    STRINGS.ERROR_STRINGS.UNABLE_TO_REQUEST
                  }
                />
              )}
              {((languageSelector && sorensonUser.userType === UserType.VRS) ||
                (vriLanguageSelector &&
                  sorensonUser.userType === UserType.VRI)) && (
                <LanguageSelector
                  initialLoad={initialLoad}
                  disabled={!canRequest}
                  setLanguage={setLanguage}
                />
              )}

              {isInMeeting &&
              !initialLoad &&
              !isHost &&
              !isGettingMeetingInfo ? (
                <CardAlertContainer
                  severity='warning'
                  mainText={
                    'It looks like you’re not hosting this meeting. That’s ok! Try '
                  }
                  linkText='Sorenson for Zoom on the web.'
                  url='https://engage.sorensonprod.com/sign-in'
                />
              ) : null}
              {initialLoad ? (
                <Skeleton
                  id='skeleton-container'
                  variant='rectangular'
                  sx={{ borderRadius: '8px' }}
                  width='100%'
                  height={56}
                />
              ) : (
                <>
                  <LoadingButton
                    id='get-asl-interpreter'
                    onClick={handleSumbit}
                    type='submit'
                    loading={requestLoading}
                    disabled={
                      !isHost ||
                      !currentMeeting?.joinUrl ||
                      requestLoading ||
                      !canRequest
                    }
                  >
                    Get an ASL interpreter
                  </LoadingButton>
                </>
              )}
            </>
          ) : (
            <Unavailable />
          )}
        </Page>
      ) : (
        isInMeeting && <LoadingScreen />
      )}
    </>
  );
};
export default JoinInterpreter;
